import { InvestorCapitalAccountItemValueDTO } from '../DTOs/capital-account/InvestorCapitalAccountItemValueDTO';
import { InvestorCapitalAccount } from './InvestorCapitalAccount';
import { ItemAllocationMethod } from './ItemAllocationMethod';

export class InvestorCapitalAccountItemValue {
  uuid: string;
  investor: InvestorCapitalAccount;
  itemAllocationMethod: ItemAllocationMethod;
  manualValue: number;

  constructor(
    uuid: string,
    investor: InvestorCapitalAccount,
    itemAllocationMethod: ItemAllocationMethod,
    manualValue: number,
  ) {
    this.uuid = uuid;
    this.investor = investor;
    this.itemAllocationMethod = itemAllocationMethod;
    this.manualValue = manualValue;
  }

  static toInvestorCapitalAccountItemMethodDTO(entity: InvestorCapitalAccountItemValue): InvestorCapitalAccountItemValueDTO {
    return new InvestorCapitalAccountItemValueDTO(
      entity.uuid,
      InvestorCapitalAccount.toDTO(entity.investor),
      ItemAllocationMethod.toDTO(entity.itemAllocationMethod),
      entity.manualValue,
    );
  }

  static arrayToInvestorCapitalAccountItemMethodDTOList(entities: InvestorCapitalAccountItemValue[]): InvestorCapitalAccountItemValueDTO[] {
    return entities.map((dto) => InvestorCapitalAccountItemValue.toInvestorCapitalAccountItemMethodDTO(dto));
  }
}
